import { Theme, ThemePreset } from '../models/theme.model';

export const THEME_STORAGE_KEY = 'app-theme';
export const VALID_THEMES: Theme[] = ['light', 'dark', 'auto'];
export const VALID_PRESETS: ThemePreset[] = ['default', 'vibrant'];

export function migrateStorageFormat(): void {
  if (typeof localStorage === 'undefined') return;

  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (!stored) return;

  if (stored === 'true' || stored === 'false') {
    const migrated: Theme = stored === 'true' ? 'dark' : 'light';
    localStorage.setItem(
      THEME_STORAGE_KEY,
      JSON.stringify({ theme: migrated, preset: 'default' })
    );
    return;
  }

  if (stored === 'light' || stored === 'dark' || stored === 'auto') {
    localStorage.setItem(
      THEME_STORAGE_KEY,
      JSON.stringify({ theme: stored, preset: 'default' })
    );
    return;
  }

  try {
    const parsed = JSON.parse(stored);
    if (!parsed.theme || !VALID_THEMES.includes(parsed.theme)) {
      localStorage.removeItem(THEME_STORAGE_KEY);
      return;
    }
    if (!parsed.preset) {
      parsed.preset = 'default';
      localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(parsed));
    } else if (!VALID_PRESETS.includes(parsed.preset)) {
      parsed.preset = 'default';
      localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(parsed));
    }
  } catch {
    localStorage.removeItem(THEME_STORAGE_KEY);
  }
}

export function getStoredTheme(): Theme {
  if (typeof localStorage === 'undefined') return 'light';

  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (!stored) return 'light';

  try {
    const parsed = JSON.parse(stored);
    if (parsed.theme && VALID_THEMES.includes(parsed.theme)) {
      return parsed.theme;
    }
  } catch {
    // Invalid JSON - migration should have handled this
  }

  return 'light';
}

export function getStoredPreset(): ThemePreset {
  if (typeof localStorage === 'undefined') return 'default';

  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (!stored) return 'default';

  try {
    const parsed = JSON.parse(stored);
    if (parsed.preset && VALID_PRESETS.includes(parsed.preset)) {
      return parsed.preset;
    }
  } catch {
    // Invalid JSON - migration should have handled this
  }

  return 'default';
}
